import React from 'react';
import { Linking, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Email } from '@/ui/icons';
import { Call } from '@/ui/icons/call';
import { MenuItem } from '@/ui/menu-item';

export default function ContactSupport({ style }: { style?: any }) {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={[{ gap: 16, flexGrow: 1 }, style]}>
      <Text tx="subscriptions.furtherQuestions" type="title1" />

      <View style={{ gap: 16 }}>
        <MenuItem
          leftIcon={<Call />}
          leftIconFillColor={theme.colors.icon.color}
          tx="supportFaq.supportNumber"
          tx2="supportFaq.generalSupport"
          onPress={() => {
            Linking.openURL('tel:+18555987090');
          }}
          style={styles.menuItem}
        />

        <MenuItem
          leftIcon={<Email />}
          leftIconFillColor={theme.colors.icon.color}
          tx="supportFaq.supportEmail"
          tx2="supportFaq.emailRespondTime"
          onPress={() => {
            Linking.openURL('mailto:support@eonrides.com');
          }}
          style={styles.menuItem}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  menuItem: {
    borderWidth: 1,
    borderColor: theme.colors.card.default.borderColor,
    width: {
      md: '100%',
    },
  },
}));
